import { Button, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { type InvoiceMonthlyDetailFeeType, invoiceMonthlyDetailDefaultFeeTypes } from '@parkchirp/reporting';
import { useCallback } from 'react';

type Props = {
	selectedFeeTypes: InvoiceMonthlyDetailFeeType[];
	onChange: (value: InvoiceMonthlyDetailFeeType[]) => void;
};

export const FeeTypesFilter = ({ selectedFeeTypes, onChange }: Props) => {
	const allSelected = selectedFeeTypes.length === invoiceMonthlyDetailDefaultFeeTypes.length;

	const selectAll = useCallback(() => {
		onChange([...invoiceMonthlyDetailDefaultFeeTypes]);
	}, [onChange]);

	const clear = useCallback(() => {
		onChange([]);
	}, [onChange]);

	const handleFeeTypeChange = useCallback(
		(feeType: InvoiceMonthlyDetailFeeType, checked: boolean) => {
			if (checked) {
				onChange([...selectedFeeTypes, feeType]);
				return;
			}

			onChange(selectedFeeTypes.filter((selected) => selected !== feeType));
		},
		[onChange, selectedFeeTypes],
	);

	return (
		<Stack spacing={2}>
			<Stack direction='row' justifyContent='space-between' alignItems='center'>
				<Typography variant='subtitle1' fontWeight={600}>
					Fee types
				</Typography>

				<Stack direction='row' spacing={1}>
					<Button size='small' variant='text' onClick={selectAll} disabled={allSelected}>
						Select all
					</Button>
					<Button size='small' variant='text' onClick={clear} disabled={selectedFeeTypes.length === 0}>
						Clear
					</Button>
				</Stack>
			</Stack>

			<Stack direction='row' flexWrap='wrap' columnGap={3} rowGap={1}>
				{invoiceMonthlyDetailDefaultFeeTypes.map((feeType) => (
					<FormControlLabel
						key={feeType}
						control={
							<Checkbox
								checked={selectedFeeTypes.includes(feeType)}
								onChange={(event) => handleFeeTypeChange(feeType, event.target.checked)}
							/>
						}
						label={feeType}
					/>
				))}
			</Stack>
		</Stack>
	);
};
